/** PRM-27 toast timings — 07-11 */
export const TOAST_DURATION_MS = 6_000;
export const TOAST_ACTION_DURATION_MS = 20_000;
export const TOAST_MAX_VISIBLE = 3;

export const TOAST_TYPES = ['info', 'success', 'error', 'offline'] as const;
export type ToastType = (typeof TOAST_TYPES)[number];

export const OFFLINE_TOAST_MESSAGE =
  'You appear to be offline. Some actions are unavailable until you reconnect.';

export const ONLINE_RECOVERY_MESSAGE = 'Back online.';
